import { FormStateType } from "../../../../types";
import { CLAIM_VALIDATION_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [CLAIM_VALIDATION_CONSTANTS.ALL_CLAIM_VALIDATION_FIELDS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.PRODUCT_CAUSED_INJURIES_OR_DAMAGES]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.REQUESTING_ITEM_REMOVAL]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.SHARING_NEGATIVE_FEEDBACK]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.REFUND_REQUEST_ONLY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.SEEKING_ADDITIONAL_COMPENSATION]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [CLAIM_VALIDATION_CONSTANTS.DELIVERY_ISSUE_RELATED]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
